export interface SuperPropertiesConfig<
  TSuperProps extends Record<string, unknown> = Record<string, unknown>,
> {
  initialProps?: TSuperProps;
}

export interface SuperPropertiesPlugin<
  TSuperProps extends Record<string, unknown> = Record<string, unknown>,
> {
  name: 'super-properties';
  methods: {
    setSuperProperty: <K extends keyof TSuperProps>(
      key: K,
      value: TSuperProps[K],
    ) => void;
    getSuperProperties: () => TSuperProps;
  };
  trackStart: ({
    payload,
  }: {
    payload: { properties?: Record<string, unknown> } & Record<string, unknown>;
  }) => { properties: TSuperProps & Record<string, unknown> } & Record<
    string,
    unknown
  >;
  pageStart: ({
    payload,
  }: {
    payload: { properties?: Record<string, unknown> } & Record<string, unknown>;
  }) => { properties: TSuperProps & Record<string, unknown> } & Record<
    string,
    unknown
  >;
  identifyStart: ({
    payload,
  }: {
    payload: { traits?: Record<string, unknown> } & Record<string, unknown>;
  }) => { traits: TSuperProps & Record<string, unknown> } & Record<
    string,
    unknown
  >;
}

export function superPropertiesPlugin<
  TSuperProps extends Record<string, unknown> = Record<string, unknown>,
>(
  config: SuperPropertiesConfig<TSuperProps> = {},
): SuperPropertiesPlugin<TSuperProps> {
  const superProps: TSuperProps = (config.initialProps || {}) as TSuperProps;

  return {
    name: 'super-properties',
    methods: {
      setSuperProperty(key, value) {
        superProps[key] = value;
      },
      getSuperProperties() {
        return superProps;
      },
    },
    trackStart: ({ payload }) => {
      const result = {
        ...payload,
        properties: {
          ...superProps,
          ...payload.properties,
        },
      };
      return result;
    },
    pageStart: ({ payload }) => {
      const result = {
        ...payload,
        properties: {
          ...superProps,
          ...payload.properties,
        },
      };
      return result;
    },
    identifyStart: ({ payload }) => {
      const result = {
        ...payload,
        traits: {
          ...superProps,
          ...payload.traits,
        },
      };
      return result;
    },
  };
}
